import type { PropsWithChildren } from 'react';

import { container } from './PieChartOverlays.sty.js';
import { Flex } from '../../../../layouts/flex/Flex.js';
import { useChartLayoutLoading } from '../../../core/components/chart-layout/hooks/useChartLayoutLoading.js';
import { useOverlay } from '../../../core/components/overlay-tooltip/contexts/OverlayContext.js';
import { isToolbarEnabled } from '../../../core/utils/is-toolbar-enabled.js';
import { useToolbarConfig } from '../../context/ToolbarContext.js';
import { useOverlayHandlers } from '../../hooks/useOverlayHandlers.js';
import { PieChartToolbar } from '../PieChartToolbar/PieChartToolbar.js';
import { PieChartTooltip } from '../PieChartTooltip/PieChartTooltip.js';

export const PieChartOverlays = ({ children }: PropsWithChildren) => {
  const overlay = useOverlay();
  const loading = useChartLayoutLoading();
  const { onPointerEnterHandler, onPointerLeaveHandler } = useOverlayHandlers();

  const toolbarConfig = useToolbarConfig();

  const toolbarEnabled = isToolbarEnabled(toolbarConfig);

  return (
    <Flex
      ref={overlay.overlayRef}
      data-testid="overlays-wrapper"
      justifyContent="center"
      alignItems="center"
      className={container}
      onPointerEnter={loading ? undefined : onPointerEnterHandler}
      onPointerLeave={loading ? undefined : onPointerLeaveHandler}
    >
      {!loading && <PieChartTooltip />}
      {!loading && toolbarEnabled && <PieChartToolbar />}
      {children}
    </Flex>
  );
};
